const keyContactsRawData = [
    {
        id: 1,
        name: "Lisa Anderson",
        role: "VP, AI Solutions",
        lastTalked: "Oct. 15, 2024",
        details: "Discussed AI scaling challenges",
        email: "lisa@abc.com",
        image: require("../../images/contact_1.jpeg"), 
    },
    {
        id: 2,
        name: "Michael Chen",
        role: "Director, Data Center Operations",
        lastTalked: "Oct. 18, 2024",
        details: "Requested integration details",
        email: "michael@abc.com",
        image: require("../../images/contact_2.jpeg"), 
    },
];

export default keyContactsRawData;
